/**
 * The contract version this package speaks.
 *
 * The one precedent in the estate for sharing front-end code across repositories is
 * `reicon-react`, and its two consumers (ICRM and Accounts) are already on different
 * versions with different adapter layers. The lesson is not "do not share" — it is
 * "version the contract and say what changed", so a host can tell at a glance whether the
 * package it has installed matches the module its backend is running.
 *
 * `CONTRACT_VERSION` moves when the *wire* contract moves: a new enum member, a renamed
 * field, a new required request field, a changed idempotency rule. Cosmetic changes to a
 * skin do not move it.
 *
 * `SERVER_SLICES` records which build slices of PROJECT.md this client covers. A host
 * running a backend older than the highest slice listed will 404 on some routes.
 */
export const CONTRACT_VERSION = '1.0.0';
/** Slices whose API surface this client speaks. Slice 8 is the UI itself. */
export const SERVER_SLICES = Object.freeze([1, 2, 3, 7]);
/**
 * Server routes deliberately NOT covered yet, so nobody has to grep to find out:
 * valuation (slice 4), traceability/batch/serial/recall (slice 5), stock transfers
 * (slice 3), procurement (slice 6). All are reachable through
 * `client.transport.request(...)` in the meantime.
 */
export const UNCOVERED_AREAS = Object.freeze([
    'valuation',
    'traceability',
    'transfers',
    'procurement',
]);
//# sourceMappingURL=version.js.map